export default {
  'google': require('@/assets/logo/logo_google.svg'),
  'gmail': require('@/assets/logo/gmail.png'),
  'outlook': require('@/assets/logo/outlook_messaging.png'),
}
